module.exports = __webpack_public_path__ + "static/media/about-img-bg.865a4c50.png";